import {BaseTabs} from '../../../application/baseTabs';
import {SearchContent} from './searchContent';
import {CategoryContent} from './categoryContent';

class Tabs extends BaseTabs
{
    /**
     * @param {string|null} searchQuery
     */
    loadSearchTabContent(searchQuery) {
        let toggleButton = this.container.querySelector('[data-tabs="button"][data-load="search"]'),
            tabContent = this.container.querySelector('[data-tabs="content"][data-load="search"]'),
            statusHandler = tabContent.querySelector('[data-tab="status"]');

        statusHandler.textContent = statusHandler.getAttribute('data-progress');
        /** @param {{content: string, count: int}} contentData */
        new SearchContent(toggleButton.getAttribute('data-endpoint'), searchQuery, (contentData) => {
            if (contentData.count) {
                tabContent.querySelector('[data-content="list"]').innerHTML = contentData.content;
                statusHandler.textContent = statusHandler.getAttribute('data-found') + ' ' + contentData.count;
            } else {
                statusHandler.textContent = statusHandler.getAttribute('data-error');
            }
        });
    }

    clearSearchTabContent() {
        let tabContent = this.container.querySelector('[data-tabs="content"][data-load="search"]'),
            statusHandler = tabContent.querySelector('[data-tab="status"]');

        statusHandler.textContent = statusHandler.getAttribute('data-progress');
        tabContent.querySelector('[data-content="list"]').innerHTML = '';
    }

    /**
     * @param {Number} categoryId
     */
    loadCategoryTabContent(categoryId) {
        let toggleButton = this.container.querySelector('[data-tabs="button"][data-load="category"]'),
            tabContent = this.container.querySelector('[data-tabs="content"][data-load="category"]');

        /** @param {{content: string, count: int}} contentData */
        new CategoryContent(toggleButton.getAttribute('data-endpoint'), categoryId, (contentData) => {
            tabContent.querySelector('[data-content="list"]').innerHTML = contentData.count ? contentData.content : '';
        });
    }
}

export {Tabs};
